





















































































import _ from "lodash";
import {
  AccomodationUnitTypeLOSCategory,
  AccomodationUnitTypeViewModel,
} from "@/shared/models/accomodationUnitTypeViewModel";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { ListModel } from "@/shared/models/listModel";
import { Notification } from "@/store/modules/notifications";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import { DataOptions } from "vuetify";
import NumericInput from "../misc/NumericInput.vue";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import { Currency } from "@/shared/models/currency";
import AccomodationUnitTypeLOSCategoriesForm from "./AccomodationUnitTypeLOSCategoriesForm.vue";

@Component({
  components: {
    NumericInput,
    RightDrawer,
    SortableHeadersTable,
    AccomodationUnitTypeLOSCategoriesForm,
  },
})
export default class AccomodationUnitTypeLOSCategories extends Vue {
  @Prop() model?: AccomodationUnitTypeViewModel;

  loading = true;
  settingsOpen = false;
  losCategories: AccomodationUnitTypeLOSCategory[] = [];

  formOpen = false;

  @Getter("appParams/tenantUsesInputPrice") tenantUsesInputPrice?: boolean;
  @Getter("appParams/workingCurrency") workingCurrency?: Currency;

  // load existing categories and global templates
  load() {
    if (!this.model?.id) return;
    this.loading = true;
    this.axios
      .get<ListModel<AccomodationUnitTypeLOSCategory>>(
        `/AccomodationUnitTypes/${this.model.id}/losCategories`
      )
      .then((res) => {
        this.losCategories = res.data.result;
      })
      .finally(() => (this.loading = false));
  }

  debouncedLoad = _.debounce(this.load, 500);

  refresh() {
    this.debouncedLoad();
    this.$emit('saved');
  }

  headers: SortableTableHeader[] = [];

  setupHeaders() {
    this.headers = [
      {
        text: "AccomodationUnitType.LOSCategories.MinStay",
        value: "minStay",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "AccomodationUnitType.LOSCategories.MaxStay",
        value: "maxStay",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      ...(this.tenantUsesInputPrice
        ? [
            {
              text: "OB.LOS.Category.InputPriceDifference",
              value: "inputPriceDifference",
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
          ]
        : []),
      {
        text: "OB.LOS.Category.OutputPriceDifference",
        value: "outputPriceDifference",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "AccomodationUnitType.LOSCategories.IsDefault",
        value: "isDefault",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        active: true,
        default: true,
        class: "resize-header",
        exportHeaders: [],
      },
    ];
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["minStay"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  async created() {
    this.setupHeaders();
  }

  mounted() {
    this.load();
  }

  add() {
    this.formOpen = true;
  }

  updateCategoryId: number | null = null;
  update(category: AccomodationUnitTypeLOSCategory) {
    this.updateCategoryId = category.id;
    this.formOpen = true;
  }

  rowDoubleClick(
    e: MouseEvent,
    { item }: { item: AccomodationUnitTypeLOSCategory }
  ) {
    this.update(item);
  }

  remove(category: AccomodationUnitTypeLOSCategory) {
    this.$store.dispatch("showNotification", {
      id: category.id,
      color: "warning",
      message: this.$t("UnitTypeLOSCategory.DeleteConfirmation"),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteConfirmed(category.id);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  deleteConfirmed(id: number, overrides: string[] = []) {
    const handleCodes = ["RatePlan.DeleteValidation.OtaSync"];
    const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

    // prettier-ignore
    const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

    const isOverriding = overrides.length !== 0;

    this.loading = true;

    Vue.axios
      .delete(`/AccomodationUnitTypes/${this.model?.id}/losCategories/${id}`, {
        data: { overrideRules: overrides },
        adapter: isOverriding ? undefined : adapter,
      })
      .then(() => {
        const toRemove = this.losCategories.find((x) => x.id === id);
        if (toRemove) {
          this.losCategories = this.losCategories.filter((x) => x.id !== id);
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("UnitTypeLOSCategory.DeleteSuccess"),
            timeout: 5000,
          } as Notification);
        }
      })
      .catch((x) => {
        if (x && x.isHandleBrokenRuleResult && !isOverriding) {
          this.$store.dispatch("showNotification", {
            color: "warning",
            message:
              // prettier-ignore
              `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
            timeout: 30000,
            actions: [
              {
                text: this.$t("Yes"),
                fun: () => {
                  this.deleteConfirmed(id, x.handled);
                  return true;
                },
              },
              { text: this.$t("Cancel"), fun: () => true },
            ],
          } as Notification);
        } else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: `${formatBrokenRuleNames(x.unhandled)}`,
            timeout: 5000,
          } as Notification);
        }
      })
      .finally(() => (this.loading = false));
  }

  inputPriceDifferenceData(item: AccomodationUnitTypeLOSCategory) {
    if (
      item.inputPriceDifference &&
      item.inputPriceDifferenceIsAbsolute !== null
    ) {
      return (
        item.inputPriceDifference.toFixed(2) +
        (!item.inputPriceDifferenceIsAbsolute
          ? "%"
          : " " + this.workingCurrency?.isoCode)
      );
    }
  }
  
  outputPriceDifferenceData(item: AccomodationUnitTypeLOSCategory) {
    if (
      item.outputPriceDifference &&
      item.outputPriceDifferenceIsAbsolute !== null
    ) {
      return (
        item.outputPriceDifference?.toFixed(2) +
        (!item.outputPriceDifferenceIsAbsolute
          ? "%"
          : " " + this.workingCurrency?.isoCode)
      );
    }
  }
}
